import { getTailwindConfig } from "@/utils/getTailwindConfig";

export const getSizesString = ({
  sm,
  md,
  lg,
  rest,
}: {
  sm: number;
  md: number;
  lg: number;
  rest: number;
}) => {
  const fullConfig = getTailwindConfig();

  const returnString = `(max-width: ${
    (fullConfig.theme!.screens as { sm: string }).sm
  }) ${sm}vw, (max-width: ${
    (fullConfig.theme!.screens as { md: string }).md
  }) ${md}vw, (max-width: ${
    (fullConfig.theme?.screens as { lg: string }).lg
  }) ${lg}vw, ${rest}vw`;
  return returnString;
};
